import React from 'react';
import {Control, UseFormRegister} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import PremiumCheckbox from 'shared/ui/Checkbox/PremiumCheckbox/PremiumCheckbox';
import InputText from 'shared/ui/Input/InputText';
import InputHidden from 'shared/ui/Input/InputHidden';
import IHttpMonitorOutput from 'features/http/model/HttpMonitor/IHttpMonitor';
import {isTranslate} from 'shared/lib/lang';

import SettingsArrow from '../../SettingsArrow/SettingsArrow';
import FieldCard from '../FieldCard/FieldCard';

import styles from '../CheckboxBlock.module.scss';

interface IBasicAuthFieldProps {
    item?: IHttpMonitorOutput,
    control: Control<any>,
    register: UseFormRegister<any>,
    selective: boolean,
    freeTariff: boolean,
    enabled: boolean,
    isChecked: boolean,
    onRemove?: () => void,
}

const BasicAuthField: React.FC<IBasicAuthFieldProps> = ({
    item,
    control,
    register,
    selective,
    freeTariff,
    enabled,
    isChecked,
    onRemove,
}) => (
    <FieldCard selective={selective} freeTariff={freeTariff} auth onRemove={onRemove}>
        <PremiumCheckbox
            label={t`Авторизация HTTP Basic`}
            helpText={t`Позволяет настроить доступ к сайту с авторизацией по логину и паролю (HTTP Basic).`}
            register={register('auth_enabled')}
            enabled={enabled}
            comingSoon={isTranslate()}
        />
        {!selective && !isTranslate() && !freeTariff &&
            <SettingsArrow checkboxName="auth_enabled" isOpen={isChecked}/>
        }

        {!isTranslate() && isChecked && enabled && (
            <div className={styles.blockInput}>
                <InputText
                    defaultValue={item?.auth?.login}
                    name="auth.login"
                    register={register}
                    control={control}
                    placeholder={t`Логин`}
                />
                <InputHidden {...register('auth.type')} value="Basic"/>
                <InputText
                    defaultValue={item?.auth?.password}
                    name="auth.password"
                    register={register}
                    control={control}
                    placeholder={t`Пароль`}
                />
            </div>
        )}
    </FieldCard>
);

export default BasicAuthField;
